import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../lib/motion";
import { CASES } from "../data";

export const CaseStudies = () => (
  <section id="work" className="relative border-t border-black/10 bg-[#f4f4f1] py-28 md:py-36" data-testid="cases-section">
    <div className="container-vx">
      <div className="mb-16 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <div className="max-w-2xl">
          <Reveal>
            <span className="label-mono">/ Selected work</span>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-sans text-4xl font-light leading-tight tracking-tight md:text-5xl">
              Outcomes that compound.
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.2}>
          <p className="max-w-xs font-body text-neutral-600">
            A glimpse at the systems quietly running behind category leaders.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-8">
        {CASES.map((c, i) => (
          <Reveal key={c.client} delay={i * 0.12}>
            <a
              href="#contact"
              data-testid={`case-card-${i}`}
              className="group block"
            >
              <div className="spotlight-img relative aspect-[16/10] overflow-hidden rounded-3xl border border-black/10 card-shadow">
                <img
                  src={c.img}
                  alt={c.client}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent" />
                <div className="absolute right-6 top-6 inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/25 bg-black/30 text-white opacity-0 backdrop-blur-md transition-all duration-500 group-hover:opacity-100">
                  <ArrowUpRight className="h-5 w-5" />
                </div>
                <div className="absolute bottom-0 left-0 right-0 flex items-end justify-between p-7">
                  <div>
                    <div className="font-mono text-xs uppercase tracking-widest text-white/70">
                      {c.sector}
                    </div>
                    <div className="mt-1 font-sans text-2xl font-medium tracking-tight text-white">
                      {c.client}
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="font-sans text-4xl font-light tracking-tight text-white md:text-5xl">
                      {c.metric}
                    </div>
                  </div>
                </div>
              </div>
              <p className="mt-5 max-w-md font-body text-neutral-600">
                <span className="font-medium text-black">{c.metric}</span> {c.result}
              </p>
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
